"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fluid = fluid;
const uom_1 = require("uom");
const uom_2 = require("@genesys/uom");
const value_1 = require("./value");
function fluid(cooling) {
    const category = cooling ? "Wet " : "Dry ";
    return [
        (0, value_1.createAmount)(category + "temperature", uom_1.Amount.create(28, uom_2.Units.Celsius), uom_2.Units.Celsius, uom_2.Units.Fahrenheit),
        (0, value_1.createAmount)(category + "humidity", uom_1.Amount.create(0, uom_2.Units.GramPerKilogram), uom_2.Units.GramPerKilogram, uom_2.Units.GrainPerPoundLb),
        (0, value_1.createAmount)(category + "pressure", uom_1.Amount.create(101325, uom_2.Units.Pascal), uom_2.Units.Pascal, uom_2.Units.PoundForcePerSquareInch),
        (0, value_1.createAmount)(category + "fluid temperature in", uom_1.Amount.create(cooling ? 8 : 80, uom_2.Units.Celsius), uom_2.Units.Celsius, uom_2.Units.Fahrenheit)
    ];
}
//# sourceMappingURL=fluid.js.map